"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.string.starts-with");
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.array.sort");
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.array.find");
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _SwPage = _interopRequireDefault(require("@/views/common/SwPage"));
var _shopList = require("@/api/shop/shopList");
var _menuStoreTemplate = require("@/api/goods/menuStoreTemplate");
var _goods = require("@/api/goods/goods");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var menuTypeOptions = [{
  key: 1,
  value: '普通模板'
}, {
  key: 2,
  value: '分时段模板'
}, {
  key: 3,
  value: '团餐模板'
}];
var menuTypeKeyValue = menuTypeOptions.reduce(function (acc, cur) {
  acc[cur.key] = cur.value;
  return acc;
}, {});
var _default = exports.default = {
  name: 'menuStoreTemplateManage',
  components: {
    SwPage: _SwPage.default
  },
  directives: {
    waves: _waves.default
  },
  filters: {
    menuTypeFilter: function menuTypeFilter(key) {
      return menuTypeKeyValue[key];
    }
  },
  data: function data() {
    return {
      storeQuery: {
        keywords: null
      },
      storeData: [{
        children: []
      }],
      listLoading: false,
      templateList: [],
      currentTime: new Date(),
      activeScene: '1',
      selectedStoreId: null,
      selectedGroupId: null,
      currentTemplateId: null,
      currentTemplateGroups: [],
      dataList: [],
      editVisible: false,
      editForm: {},
      thumbnailFileList: [],
      coverFileList: [],
      resPath: '',
      selectedItemsPool: {},
      // 存储所有选中项的完整数据 {id: item}
      isRendering: false,
      // 标志位，防止渲染时触发selection-change
      isAllSelected: false,
      templateListCollapsed: false,
      categoryListCollapsed: false,
      storePanelCollapsed: false,
      templatePanelCollapsed: false,
      expandedGroups: [],
      weekdays: [{
        label: '周一',
        value: 1
      }, {
        label: '周二',
        value: 2
      }, {
        label: '周三',
        value: 3
      }, {
        label: '周四',
        value: 4
      }, {
        label: '周五',
        value: 5
      }, {
        label: '周六',
        value: 6
      }, {
        label: '周日',
        value: 7
      }],
      // 预览相关
      previewDialogVisible: false,
      previewQrCode: '',
      previewLoading: false,
      previewMediaDialog: {
        visible: false,
        url: '',
        isVideo: false
      }
    };
  },
  created: function created() {
    this.handleStoreFilter();
  },
  methods: {
    // 获取分类的商品数量
    getGroupItemCount: function getGroupItemCount(groupId) {
      var group = this.dataList.find(function (g) {
        return g.id === groupId;
      });
      return group && group.items ? group.items.length : 0;
    },
    // 切换模板列表展开/收起
    toggleTemplateList: function toggleTemplateList() {
      this.templateListCollapsed = !this.templateListCollapsed;
    },
    // 切换分类列表展开/收起
    toggleCategoryList: function toggleCategoryList() {
      this.categoryListCollapsed = !this.categoryListCollapsed;
    },
    // 切换门店面板左右收起
    toggleStorePanel: function toggleStorePanel() {
      var _this = this;
      // 使用 requestAnimationFrame 优化动画性能
      requestAnimationFrame(function () {
        _this.storePanelCollapsed = !_this.storePanelCollapsed;
      });
    },
    // 切换模板面板左右收起
    toggleTemplatePanel: function toggleTemplatePanel() {
      var _this2 = this;
      requestAnimationFrame(function () {
        _this2.templatePanelCollapsed = !_this2.templatePanelCollapsed;
        // 收起面板时，同时收起内部的展开内容
        if (_this2.templatePanelCollapsed) {
          _this2.templateListCollapsed = true;
          _this2.categoryListCollapsed = true;
        }
      });
    },
    // 获取可见的商品列表（限制显示数量）
    getVisibleItems: function getVisibleItems(group) {
      if (!group.items) return [];
      // 如果已展开或数量不超过10条，显示全部
      if (this.expandedGroups.includes(group.id) || group.items.length <= 10) {
        return group.items;
      }
      // 只显示前10条
      return group.items.slice(0, 10);
    },
    // 切换分组展开状态
    toggleGroupExpand: function toggleGroupExpand(groupId) {
      var isExpanded = this.expandedGroups.includes(groupId);

      // 切换展开状态
      if (isExpanded) {
        var index = this.expandedGroups.indexOf(groupId);
        this.expandedGroups.splice(index, 1);
      } else {
        this.expandedGroups.push(groupId);
      }

      // 展开/收起后重新渲染所有表格的选中状态
      this.renderAllSelectionStates();
    },
    // 判断分组是否已展开
    isGroupExpanded: function isGroupExpanded(groupId) {
      return this.expandedGroups.includes(groupId);
    },
    handleCache: function handleCache() {
      var _this3 = this;
      if (!this.selectedStoreId) {
        this.$message.error('请先选择门店');
        return;
      }
      this.$confirm('确认要缓存该模板吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this3.listLoading = true;
        (0, _menuStoreTemplate.cacheById)(_this3.selectedStoreId).then(function (res) {
          if (res.code === 200) {
            _this3.$message.success('操作成功');
          } else {
            _this3.$message.error(res.message || '缓存失败');
          }
        }).catch(function (error) {
          _this3.$message.error(error.message || '缓存失败');
        }).finally(function () {
          _this3.listLoading = false;
        });
      }).catch(function () {});
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.editForm.checkedWeekdays = val ? [1, 2, 3, 4, 5, 6, 7] : [];
    },
    // 表格单行选择/取消选择
    handleRowSelect: function handleRowSelect(selection, row, group) {
      var isSelected = selection.some(function (item) {
        return item.id === row.id;
      });
      if (isSelected) {
        this.$set(this.selectedItemsPool, row.id, row);
      } else {
        this.$delete(this.selectedItemsPool, row.id);
      }
      this.checkAllSelectedStatus();
    },
    // 表格自带的全选框（点击表头全选框）：支持全选包括未展开的所有数据
    handleSelectAllGroup: function handleSelectAllGroup(selection, group) {
      var _this4 = this;
      var isSelectAll = selection && selection.length > 0;
      if (isSelectAll) {
        // 全选：将该分组所有数据（包括未展开数据）全部加入 pool
        if (group.items && group.items.length > 0) {
          group.items.forEach(function (item) {
            _this4.$set(_this4.selectedItemsPool, item.id, item);
          });
          var hiddenCount = group.items.length - selection.length;
          if (hiddenCount > 0) {
            this.$message.success("\u5DF2\u9009\u4E2D\u3010".concat(group.templateGroupName, "\u3011\u5168\u90E8 ").concat(group.items.length, " \u4E2A\u83DC\u54C1\uFF08\u542B\u672A\u5C55\u5F00 ").concat(hiddenCount, " \u6761\uFF09"));
          }
        }
      } else {
        // 取消全选：将该分组所有数据（包括未展开数据）全部从 pool 中移除
        if (group.items && group.items.length > 0) {
          group.items.forEach(function (item) {
            _this4.$delete(_this4.selectedItemsPool, item.id);
          });
        }
      }
      this.checkAllSelectedStatus();
    },
    // 重新渲染所有表格的选中状态
    renderAllSelectionStates: function renderAllSelectionStates() {
      var _this5 = this;
      // 如果已经在渲染，不重复渲染
      if (this.isRendering) return;
      this.isRendering = true;
      this.$nextTick(function () {
        _this5.renderAllSelectionStatesInternal();

        // 渲染完成后清除标志位
        setTimeout(function () {
          _this5.isRendering = false;
          // 检查全选状态
          _this5.checkAllSelectedStatus();
        }, 100);
      });
    },
    // 内部渲染方法（不设置isRendering标志）
    renderAllSelectionStatesInternal: function renderAllSelectionStatesInternal() {
      var _this6 = this;
      this.dataList.forEach(function (group) {
        var tableRef = _this6.$refs["table_".concat(group.id)];
        if (!tableRef) return;
        var table = tableRef.length ? tableRef[0] : tableRef;
        if (!table) return;

        // 获取当前可见数据
        var visibleItems = _this6.getVisibleItems(group);

        // 根据pool中的数据来设置选中状态
        visibleItems.forEach(function (row) {
          var isSelected = _this6.selectedItemsPool[row.id] !== undefined;
          table.toggleRowSelection(row, isSelected);
        });
      });
    },
    checkAllSelectedStatus: function checkAllSelectedStatus() {
      var _this7 = this;
      var totalItems = 0;
      var selectedItems = 0;
      this.dataList.forEach(function (group) {
        totalItems += group.items ? group.items.length : 0;
        // 统计该分组在pool中的选中数量
        if (group.items) {
          group.items.forEach(function (item) {
            if (_this7.selectedItemsPool[item.id] !== undefined) {
              selectedItems++;
            }
          });
        }
      });
      this.isAllSelected = totalItems > 0 && totalItems === selectedItems;
    },
    handleSelectAll: function handleSelectAll() {
      var _this8 = this;
      this.isAllSelected = !this.isAllSelected;

      // 先设置渲染标志，防止selection-change事件干扰
      this.isRendering = true;
      if (this.isAllSelected) {
        // 全选：将所有分组的所有数据添加到pool
        this.dataList.forEach(function (group) {
          if (group.items && group.items.length > 0) {
            group.items.forEach(function (item) {
              _this8.selectedItemsPool[item.id] = item;
            });
          }
        });
        this.$message.success('已选中所有菜品（包括未展开的数据）');
      } else {
        // 取消全选：清空pool
        this.selectedItemsPool = {};
        this.$message.success('已取消全选');
      }

      // 延迟渲染，确保pool已更新
      this.$nextTick(function () {
        setTimeout(function () {
          _this8.renderAllSelectionStatesInternal();

          // 渲染完成后清除标志位
          setTimeout(function () {
            _this8.isRendering = false;
            _this8.checkAllSelectedStatus();
          }, 100);
        }, 50);
      });
    },
    getAllSelectedIds: function getAllSelectedIds() {
      return Object.keys(this.selectedItemsPool);
    },
    clearAllSelection: function clearAllSelection() {
      var _this9 = this;
      // 设置渲染标志，防止selection-change事件干扰
      this.isRendering = true;

      // 清空pool
      this.selectedItemsPool = {};
      this.isAllSelected = false;

      // 延迟渲染
      this.$nextTick(function () {
        setTimeout(function () {
          _this9.renderAllSelectionStatesInternal();

          // 渲染完成后清除标志位
          setTimeout(function () {
            _this9.isRendering = false;
          }, 100);
        }, 50);
      });
    },
    handleBatchChangeStatus: function handleBatchChangeStatus(status) {
      var _this0 = this;
      var ids = this.getAllSelectedIds();
      if (ids.length === 0) {
        this.$message.warning('请先选择商品');
        return;
      }
      this.$confirm('确认更新状态吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _menuStoreTemplate.batchChangeStatus)({
          ids: ids,
          status: status
        }).then(function (res) {
          if (res.code === 0 || res.code === 200) {
            _this0.$message.success('操作成功');
            _this0.loadTemplateItems();
          } else {
            _this0.$message.error(res.message || '操作失败');
          }
        });
      }).catch(function () {});
    },
    handleStoreFilter: function handleStoreFilter() {
      var _this1 = this;
      (0, _shopList.queryStore)(this.storeQuery).then(function (response) {
        _this1.storeData = response.data;
      });
    },
    handleStoreSelect: function handleStoreSelect(storeId) {
      var _this10 = this;
      this.selectedStoreId = storeId;
      this.selectedGroupId = null;
      this.currentTemplateId = null;
      this.currentTemplateGroups = [];
      this.dataList = [];
      this.clearAllSelection();
      (0, _menuStoreTemplate.queryList)({
        storeId: storeId
      }).then(function (response) {
        _this10.templateList = response.data || [];
        // 默认选中普通模板(type=1)，如果没有则选中第一个
        _this10.$nextTick(function () {
          if (_this10.templateList.length > 0) {
            var normalTemplate = _this10.templateList.find(function (t) {
              return t.type === 1;
            });
            if (normalTemplate) {
              _this10.handleTemplateSelect(normalTemplate);
            } else {
              _this10.handleTemplateSelect(_this10.templateList[0]);
            }
          }
        });
      });
    },
    handleTemplateSelect: function handleTemplateSelect(template) {
      this.currentTemplateId = template.id;
      this.selectedGroupId = null;
      this.dataList = [];
      this.clearAllSelection();
      // 加载该模板下的分组列表
      this.loadTemplateGroups();
      // 选择模板后自动加载该模板下所有分组的商品
      this.loadTemplateItems();
    },
    loadTemplateGroups: function loadTemplateGroups() {
      var _this11 = this;
      if (!this.currentTemplateId) {
        this.currentTemplateGroups = [];
        return;
      }
      (0, _menuStoreTemplate.getStoreTemplateGroup)({
        storeTemplateId: this.currentTemplateId,
        scene: this.activeScene
      }).then(function (response) {
        _this11.currentTemplateGroups = response.data || [];
      });
    },
    // 滚动到指定分组
    scrollToGroup: function scrollToGroup(groupId) {
      var _this12 = this;
      this.selectedGroupId = groupId;
      // 使用 requestAnimationFrame 避免强制重排
      requestAnimationFrame(function () {
        var container = _this12.$refs.productContent;
        var element = document.getElementById("group-section-".concat(groupId));
        if (container && element) {
          // 使用 offsetTop 替代 getBoundingClientRect 避免强制重排
          var scrollTop = element.offsetTop - container.offsetTop - 20;
          container.scrollTo({
            top: scrollTop,
            behavior: 'smooth'
          });
        }
      });
    },
    loadTemplateItems: function loadTemplateItems() {
      var _this13 = this;
      if (!this.currentTemplateId) {
        return;
      }
      this.listLoading = true;
      (0, _menuStoreTemplate.getStoreTemplateGroupItems)({
        storeTemplateId: this.currentTemplateId,
        scene: this.activeScene
      }).then(function (response) {
        var list = response.data || [];
        // 为每个分组设置默认的 groupStatus（如果为 null）
        list.forEach(function (group) {
          if (group.groupStatus === null || group.groupStatus === undefined) {
            group.groupStatus = 1; // 默认开启
          }
        });
        // 排序：开启的分组在上，关闭的分组在下
        _this13.dataList = list.sort(function (a, b) {
          // 如果 groupStatus 相同，按原有顺序
          if (a.groupStatus === b.groupStatus) return 0;
          // 开启(1)在上，关闭(0)在下
          return b.groupStatus - a.groupStatus;
        });
        _this13.listLoading = false;
        // 延迟清除选中状态，等待 DOM 更新完成
        _this13.$nextTick(function () {
          requestAnimationFrame(function () {
            _this13.clearAllSelection();
          });
        });
      }).catch(function () {
        _this13.listLoading = false;
      });
    },
    handleSceneChange: function handleSceneChange(scene) {
      this.activeScene = scene;
      // 切换场景时重新加载分组列表和商品数据（加载所有分组）
      if (this.currentTemplateId) {
        this.loadTemplateGroups();
        this.loadTemplateItems();
      }
    },
    handleStatusChange: function handleStatusChange(value, row) {
      var _this14 = this;
      var data = {
        id: row.id,
        status: value
      };
      (0, _menuStoreTemplate.saveStoreGroupItem)(data).then(function (res) {
        if (res.code === 0 || res.code === 200) {
          _this14.$message.success('操作成功');
          // 同步当前页面其他分组下的同一个商品状态
          if (row.goodsId && _this14.dataList) {
            _this14.dataList.forEach(function (group) {
              if (group.items) {
                group.items.forEach(function (item) {
                  if (item.goodsId === row.goodsId) {
                    item.status = value;
                  }
                });
              }
            });
          }
        } else {
          row.status = value === 1 ? 0 : 1;
          _this14.$message.error(res.message || '操作失败');
        }
      });
    },
    handleEstimateFlag: function handleEstimateFlag(value, row) {
      var _this15 = this;
      (0, _menuStoreTemplate.changeStoreGroupItemEstimateFlag)({
        id: row.id,
        estimateFlag: value
      }).then(function (res) {
        if (res.code === 0 || res.code === 200) {
          _this15.$message.success('操作成功');
          // 同步当前页面其他分组下的同一个商品估清状态
          if (row.goodsId && _this15.dataList) {
            _this15.dataList.forEach(function (group) {
              if (group.items) {
                group.items.forEach(function (item) {
                  if (item.goodsId === row.goodsId) {
                    item.estimateFlag = value;
                  }
                });
              }
            });
          }
        } else {
          row.estimateFlag = value === 1 ? 0 : 1;
          _this15.$message.error(res.message || '操作失败');
        }
      });
    },
    handleGroupStatusChange: function handleGroupStatusChange(value, group) {
      var _this16 = this;
      var data = {
        id: group.id,
        status: value
      };
      (0, _menuStoreTemplate.changeGroupStatus)(data).then(function (res) {
        if (res.code === 0 || res.code === 200) {
          _this16.$message.success('操作成功');
          // 重新加载数据并排序
          _this16.loadTemplateItems();
        } else {
          group.groupStatus = value === 1 ? 0 : 1;
          _this16.$message.error('操作失败');
        }
      }).catch(function () {
        group.groupStatus = value === 1 ? 0 : 1;
        _this16.$message.error('操作失败');
      });
    },
    handleEdit: function handleEdit(id) {
      var _this17 = this;
      this.editVisible = true;
      (0, _menuStoreTemplate.getStoreGroupItem)(id).then(function (response) {
        _this17.editForm = response.data;
        _this17.thumbnailFileList = [];
        _this17.coverFileList = [];
        if (_this17.editForm.goodsThumbnailUrl) {
          _this17.thumbnailFileList.push({
            name: _this17.editForm.goodsThumbnailUrl,
            url: _this17.resPath + _this17.editForm.goodsThumbnailUrl
          });
        }
        if (_this17.editForm.goodsImgUrl) {
          _this17.coverFileList.push({
            name: _this17.editForm.goodsImgUrl,
            url: _this17.resPath + _this17.editForm.goodsImgUrl,
            isVideo: _this17.isVideoFile(_this17.editForm.goodsImgUrl)
          });
        }
      });
    },
    handleCancelEdit: function handleCancelEdit() {
      this.editVisible = false;
      this.editForm = {};
      this.thumbnailFileList = [];
      this.coverFileList = [];
    },
    saveEntity: function saveEntity() {
      var _this18 = this;
      (0, _menuStoreTemplate.saveStoreGroupItem)(this.editForm).then(function (res) {
        if (res.code === 0 || res.code === 200) {
          _this18.$message.success('操作成功');
          _this18.editVisible = false;
          _this18.loadTemplateItems();
        } else {
          _this18.$message.error(res.message || '保存失败');
        }
      });
    },
    handlePictureUpload: function handlePictureUpload(options, type) {
      var _this19 = this;
      var file = options.file;

      // 验证文件
      if (type === 'img' && !this.validateFile(file, true)) {
        return;
      }
      if (type === 'thumbnail' && !this.validateFile(file, false)) {
        return;
      }
      var formData = new FormData();
      formData.append('file', file);
      (0, _goods.uploadPhotoAddOrUpd)(formData).then(function (response) {
        if (response.code === 200) {
          var url = response.data;
          if (type === 'thumbnail') {
            _this19.editForm.goodsThumbnailUrl = url;
            _this19.thumbnailFileList = [{
              name: url,
              url: _this19.resPath + url
            }];
          } else {
            _this19.editForm.goodsImgUrl = url;
            _this19.coverFileList = [{
              name: url,
              url: _this19.resPath + url,
              raw: file,
              isVideo: _this19.isVideoFile(url)
            }];
          }
          _this19.$message.success('上传成功');
        }
      });
    },
    handleRemoveFile: function handleRemoveFile(file, fileList, type) {
      if (type === 'thumbnail') {
        this.thumbnailFileList = fileList;
        if (fileList.length === 0) {
          this.editForm.goodsThumbnailUrl = '';
        }
      } else if (type === 'img') {
        this.coverFileList = fileList;
        if (fileList.length === 0) {
          this.editForm.goodsImgUrl = '';
        }
      }
    },
    // 判断是否为视频文件
    isVideoFile: function isVideoFile(url) {
      if (!url) return false;
      var ext = url.split('.').pop().toLowerCase();
      return ['mp4', '3gp', 'm3u8'].includes(ext);
    },
    // 验证上传文件
    validateFile: function validateFile(file) {
      var isCover = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var isImage = file.type.startsWith('image/');
      var isVideo = file.type.startsWith('video/');
      var ext = file.name.split('.').pop().toLowerCase();
      var isM3u8 = ext === 'm3u8';

      // 封面图支持图片和视频，列表图只支持图片
      if (isCover) {
        if (!isImage && !isVideo && !isM3u8) {
          this.$message.error('只能上传图片或视频文件!');
          return false;
        }
      } else {
        if (!isImage) {
          this.$message.error('只能上传图片文件!');
          return false;
        }
      }

      // 图片大小限制
      if (isImage && file.size / 1024 / 1024 > 2) {
        this.$message.error('图片大小不能超过 2MB!');
        return false;
      }

      // 视频大小限制
      if ((isVideo || isM3u8) && file.size / 1024 / 1024 > 50) {
        this.$message.error('视频大小不能超过 50MB!');
        return false;
      }
      return true;
    },
    handlePreview: function handlePreview(file) {
      if (!file) return;
      var url = file.url || file.response && file.response.data || '';
      if (!url) {
        this.$message.warning('无法获取图片/视频预览地址');
        return;
      }
      var isVideo = file.isVideo || this.isVideoFile(url);
      this.previewMediaDialog = {
        visible: true,
        url: url,
        isVideo: !!isVideo
      };
    },
    // 获取场景标签
    getSceneLabel: function getSceneLabel(scene) {
      var sceneMap = {
        '1': '堂食',
        '2': '自提',
        '3': '外卖'
      };
      return sceneMap[scene] || '';
    },
    // 预览门店菜单
    handlePreviewStoreMenu: function handlePreviewStoreMenu() {
      if (!this.selectedStoreId) {
        this.$message.warning('请先选择门店');
        return;
      }
      if (!this.currentTemplateId) {
        this.$message.warning('请先选择模板');
        return;
      }
      this.previewDialogVisible = true;
      this.previewLoading = true;
      this.previewQrCode = '';

      // 调用后端接口生成预览二维码
      this.generatePreviewQrCode();
    },
    // 生成预览二维码
    generatePreviewQrCode: function generatePreviewQrCode() {
      var _this20 = this;
      // 构建预览URL参数
      var params = {
        storeId: this.selectedStoreId,
        storeTemplateId: this.currentTemplateId,
        scene: this.activeScene // 使用当前选中的场景，默认堂食('1')
      };

      // 调用后端接口获取二维码
      (0, _menuStoreTemplate.generateStoreMenuPreviewQrCode)(params).then(function (res) {
        // 兼容code为0或200的情况
        if ((res.code === 0 || res.code === 200) && res.data) {
          _this20.previewQrCode = res.data;
          _this20.previewLoading = false;
        } else {
          _this20.$message.error('生成二维码失败');
          _this20.previewLoading = false;
        }
      }).catch(function () {
        _this20.$message.error('生成二维码失败');
        _this20.previewLoading = false;
      });
    },
    // 下载二维码
    downloadQrCode: function downloadQrCode() {
      if (!this.previewQrCode) {
        this.$message.warning('二维码未生成');
        return;
      }

      // 创建一个临时的a标签来下载图片
      var link = document.createElement('a');
      link.href = this.previewQrCode;
      link.download = "\u95E8\u5E97\u83DC\u5355\u9884\u89C8_\u95E8\u5E97".concat(this.selectedStoreId, "_\u6A21\u677F").concat(this.currentTemplateId, ".png");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    // 处理门店市场价变化
    handleMarketPriceChange: function handleMarketPriceChange(value) {
      // 如果只有一个单位价格，则同步更新单位价格
      if (this.editForm.unitList && this.editForm.unitList.length === 1) {
        this.editForm.unitList[0].price = value;
      }
    },
    // 处理单位价格变化
    handleUnitPriceChange: function handleUnitPriceChange(value) {
      // 如果只有一个单位价格，则同步更新门店市场价
      if (this.editForm.unitList && this.editForm.unitList.length === 1) {
        this.editForm.marketPrice = value;
      }
    }
  }
};